import { GridApi, GridOptions, IServerSideDatasource, IServerSideGetRowsParams, ColDef } from 'ag-grid-community';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { QueryRequest, QueryResponse } from './ratings.type';
import { toQueryRequest } from '../shared/services/ratings/ratings-api.helpers';

export class ServerGridCore<T> {
  api?: GridApi;
  readonly destroy$ = new Subject<void>();
  readonly quickFilter$ = new Subject<string>();

  columnDefs: ColDef[] = [];
  gridOptions: GridOptions = {
    rowModelType: 'serverSide',
    cacheBlockSize: 200,
    maxBlocksInCache: 10,
    blockLoadDebounceMillis: 50,
    defaultColDef: { resizable: true, sortable: true, filter: true, floatingFilter: true },
    sideBar: {
      toolPanels: ['filters'],   // shows Filters in the sidebar
      // defaultToolPanel: 'filters'  <-- remove this if present
    }
  };

  constructor() {
    this.quickFilter$
      .pipe(debounceTime(250), takeUntil(this.destroy$))
      .subscribe(() => {
        this.api?.setFilterModel(this.api?.getFilterModel() || {});
        // this.api?.refreshServerSideStore({ purge: true });
      });
  }

  // override in your component
  project(): string[] { return []; }

  // override in your component
  // return an Observable<QueryResponse<T>>
  query(_body: QueryRequest): any { throw new Error('Implement in component'); }

  makeDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        const body = toQueryRequest(params, () => this.project());
        const obs = this.query(body);
        obs.subscribe({
          next: (resp: QueryResponse<T>) =>
            params.success({ rowData: resp.rows as any[], rowCount: resp.lastRow }),
          error: (err: any) => {
            console.error('Query failed', err);
            params.fail();
          }
        });
      }
    };
  }

  destroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

